var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarMinusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    rx: 6,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.7693V13.2308H24V10.7693H8Z",
    fill: "#1A2F77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMinusIcon);
export default __webpack_public_path__ + "static/media/sidebar-minus-icon.a304beea4861e65e9058ddfb66e78497.svg";
export { ForwardRef as ReactComponent };